import { useEffect, useRef } from 'react';
import { useGLTF } from '@react-three/drei';

import { AnimationMixer, Group } from 'three';
import { RigidBody } from '@react-three/rapier';

export default function LandModel() {
  const modelLand =  useGLTF('../models/land.glb');
  const mixer = useRef(null);

  useEffect(() => {
    if (LandModel && modelLand.animations.length) {
      mixer.current = new AnimationMixer(modelLand.scene);
      const action = mixer.current.clipAction(modelLand.animations[0]);
      action.play();
    }
  }, [modelLand]);

  return (
    <>
    <group>
     <RigidBody type='fixed' colliders="trimesh">
        <primitive scale={1} position={[0, -4, 1.5]} rotation-y={Math.PI * 1.5}  object={modelLand.scene} />
      </RigidBody>
    </group>
    
    </>
  );
}
